import { FC, useState } from 'react'

import ErrorMessage from 'components/atoms/ErrorMessage'
import GoBackHeader from 'components/organisms/GoBackHeader'
import ForgotForm from 'components/organisms/ForgotForm'

import './styles.scss'

const LoginPageForgotUserIdOrPassword: FC = () => {
  const [error, setError] = useState('')

  return (
    <>
      <GoBackHeader text='Forgot Login Credentials' />
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <div className='ui-forgot-page'>
        <h3>
          Please answer the following security questions so that we can verify
          your account.
        </h3>
        <ForgotForm error={error} setError={setError} />
      </div>
    </>
  )
}

export default LoginPageForgotUserIdOrPassword
